export default __webpack_public_path__ + "static/higi-logo-62943e65230ae9c64688250abf7f4e90.png";